import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import axios from "axios"; import { handleAuthError } from "../../utils";
import withAuth from "../withAuth";
import {baseUrl} from '../../Network';
import {Button, Col, Container, Input, Row,} from "reactstrap";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaginationControls from "../../components/Common/PaginationControls";

const ManageTestimonial = () => {
    document.title = "Audit Logs | RYD Admin";

    const [loading, setLoading] = useState(false);
    const [audits, setAudit] = useState([]);
    const [auditData, setAuditData] = useState([]);
    const [auditCat, setAuditCat] = useState([]);
    const [date1, setDate1] = useState("");
    const [date2, setDate2] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 20,
        hasNextPage: false,
        hasPreviousPage: false
    });
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        fetchAuditLog();
    }, [currentPage, pageSize, searchQuery]);

    const fetchAuditLog = async () => {
        try {
            setLoading(true);
            const limit = showAll ? 10000 : pageSize;
            const params = {
                page: currentPage,
                limit: limit,
                ...(searchQuery && { search: searchQuery })
            };
            const response = await axios.get(`${baseUrl}/admin/audit/all`, { params });
            const responseData = response.data.data;
            const data = responseData?.logs || (Array.isArray(responseData) ? responseData : (responseData?.data || []));
            const paginationData = responseData?.pagination || {
                currentPage: 1,
                totalPages: 1,
                totalItems: Array.isArray(data) ? data.length : 0,
                itemsPerPage: limit,
                hasNextPage: false,
                hasPreviousPage: false
            };
            const auditArray = Array.isArray(data) ? data : [];
            setAudit(auditArray);
            setAuditData(auditArray);
            _captureAuditCategory(auditArray);
            setPagination(paginationData);
        } catch (error) { handleAuthError(error)
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageSizeChange = (size) => {
        if (size === 'all') {
            setShowAll(true);
            setPageSize(10000);
        } else {
            setShowAll(false);
            setPageSize(parseInt(size));
            setCurrentPage(1);
        }
    };

    const goToNextPage = () => {
        if (pagination.hasNextPage) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (pagination.hasPreviousPage) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

    //filter for items
    const _captureAuditCategory = (d) => {
        let _arr = [];
        d.forEach((item) => {
            _arr.push(item.title.split("/")[2]);
        })
        if (_arr.length > 0) {
            setAuditCat([...new Set(_arr)])
        }
    }

    function cFLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    //shake your bum bum if anything sup with date1 or 2
    useEffect(() => {
        filterByDateRange()
    }, [date1, date2])

    const filterByDateRange = () => {
        if (date1) {
            //filter begin
            setAuditData(audits.filter((item) => {
                return new Date(item.timestamp) >= new Date(date1 || new Date()) && new Date(item.timestamp) <= new Date(date2 || new Date());
            }))
        }
        console.log("filterByDateRange", date1, date2);
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Audit Logs"/>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <div className="mb-3">

                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
                                <span>Action Type</span>
                                <div style={{width: 200}}>
                                    <select className={'form-control'} onChange={(e) => {
                                        //update table
                                        setAuditData(audits.filter(item => item.title.includes(e.target.value)));
                                    }}>
                                        <option value={''}>All</option>
                                        {auditCat.map((item, index) => <option key={index}
                                                                               value={item}>{cFLetter(item)}</option>)}
                                    </select>
                                </div>
                                <span>From</span>
                                <div style={{width: 200}}>
                                    <Input
                                        type="date"
                                        placeholder="date from"
                                        onChange={(e) => setDate1(e.target.value)}
                                    />
                                </div>
                                <span>To</span>
                                <div>
                                    <Input
                                        type="date"
                                        placeholder="date to"
                                        onChange={(e) => setDate2(e.target.value)}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12">
                            <Row>
                                <Col xl="12">
                                    {loading ? (
                                        <div className="text-center mt-5">
                                            <div className="spinner-border text-primary" role="status">
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <table className="table align-middle">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Title</th>
                                                    <th>Agent</th>
                                                    <th>Reason(s)</th>
                                                    <th>Time</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {Array.isArray(auditData) && auditData.length > 0 ? (
                                                    auditData.map((audit, index) => {
                                                        const globalIndex = showAll 
                                                            ? index 
                                                            : (pagination.currentPage - 1) * pagination.itemsPerPage + index;
                                                        return (
                                                            <tr key={audit.id || index}>
                                                                <td>{globalIndex + 1}</td>
                                                            <td>{audit?.title}</td>
                                                            <td>{audit?.agent}</td>
                                                            <td>{audit?.reasons}</td>
                                                            <td>{new Date(audit?.timestamp).toUTCString()}</td>
                                                        </tr>
                                                        );
                                                    })
                                                ) : null}
                                                </tbody>
                                            </table>
                                            {!Array.isArray(audits) || auditData.length === 0 && (
                                                <div className="text-center mt-5">
                                                    <h3>No data available</h3>
                                                </div>
                                            )}
                                            {Array.isArray(auditData) && auditData.length > 0 && (
                                                <PaginationControls
                                                    currentPage={pagination.currentPage}
                                                    totalPages={pagination.totalPages}
                                                    totalItems={pagination.totalItems}
                                                    pageSize={pagination.itemsPerPage}
                                                    showAll={showAll}
                                                    handlePageChange={handlePageChange}
                                                    handlePageSizeChange={handlePageSizeChange}
                                                    goToNextPage={goToNextPage}
                                                    goToPreviousPage={goToPreviousPage}
                                                    canPreviousPage={pagination.hasPreviousPage}
                                                    canNextPage={pagination.hasNextPage}
                                                    paginatedDataLength={auditData.length}
                                                />
                                            )}
                                        </div>
                                    )}

                                </Col>
                            </Row>

                        </Col>
                    </Row>
                </Container>
            </div>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default withAuth(ManageTestimonial);
